import { FC, useId } from 'react';

import { SelectBeneficiaryGroup } from '@/entities/beneficiary/components/SelectBeneficiaryGroup';
import { DropdownButton } from '@/shared/components/DropdownButton';
import { BeneficiaryGroup } from '@/shared/lib/sj-orm';
import { CollectionName } from '@/shared/lib/sj-orm/types';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { BtnClose } from '../../components/BtnClose';
import { SelectItem } from '../../components/SelectItem';
import { SelectOptions } from '../../components/SelectItem/types';
import { useModalsStore } from '../../modals.store';
import { SelectBeneficiaryProps } from '../../types';

import { Actions, Body, Container, Header, MainActions, StyledDrawer, Title } from './styled';

export const SelectBeneficiaryModal: FC<SelectBeneficiaryProps> = ({
  onSelect,
  onClose,
  beneficiaryGroups,
  filter,
  selectedValue,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectBeneficiary' });
  const modals = useModalsStore();

  const formId = useId();

  const handleClose = () => {
    onClose?.();
    modals.closeModal();
  };
  const handleSubmit = (data: SelectOptions) => {
    modals.closeModal();
    onSelect(Array.isArray(data.id) ? String(data.id[0]) : data.id.toString());
  };

  const handleAddNew = (beneficiaryGroup: BeneficiaryGroup) => {
    modals.openModal({ type: 'FastCreateBeneficiary', beneficiaryGroup });
  };

  return (
    <StyledDrawer width={800} footer={null} closable={false} onClose={handleClose} open>
      <Container>
        <Header>
          <BtnClose onClick={handleClose} style={{ position: 'absolute', right: 24, top: 24 }} />
          <Title style={{ maxWidth: '80%' }} className="truncate" size={22} bold>
            {t('title')}
          </Title>
        </Header>
        <Body style={{ marginRight: 4 }} className="uikitScrollbar">
          <SelectItem
            values={[selectedValue]}
            formId={formId}
            colName={CollectionName.BENEFICIARIES}
            onSelect={handleSubmit}
            filter={filter}
          />
        </Body>
        <Actions>
          <Button type="text" onClick={handleClose}>
            {t('btnCancel')}
          </Button>
          <MainActions>
            <DropdownButton
              listPosV="top"
              btnVariant="default"
              onSelect={handleAddNew}
              renderList={(handleSelect, listRef, selectStyles) => (
                <SelectBeneficiaryGroup
                  filter={(type) => beneficiaryGroups.includes(type)}
                  style={selectStyles}
                  onSelect={handleSelect}
                  ref={listRef}
                />
              )}
            >
              {t('btnAddNew')}
            </DropdownButton>
            <Button style={{ width: 90 }} htmlType="submit" form={formId}>
              {t('btnConfirm')}
            </Button>
          </MainActions>
        </Actions>
      </Container>
    </StyledDrawer>
  );
};
